import { ReactElement, useRef } from 'react'
import { useAtom, useAtomValue } from 'jotai'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'
import { CreditLimitIncrease } from 'account-services-mfe'
import getMFEConfig from 'helpers/getMFEConfig'
import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'
import {
  ModalHeader,
  SlideInModalPortal
} from 'syf-component-library/ui/patterns/SlideInModalPortal'
import { creditLimitIncreaseContainerId } from 'const/modalContainerId'
import i18n from 'strings/i18n'

const CreditLimitIncreaseModal = (): ReactElement => {
  const [{ modalId, modalTriggerId }, updateModalStatus] =
    useAtom(modalStatusAtom)
  const headerRef = useRef(null)

  const selectedAccount = useAtomValue(selectedAccountAtom)

  const mfeConfig = getMFEConfig('mfe')

  const handleCloseModal = () => {
    updateModalStatus('')
  }

  const handleEscapeAndModalHeader = () => {
    triggerAnalyticsEvent({
      pageFunction: 'account services',
      pageKind: 'account services'
    })
    handleCloseModal()
  }

  return (
    <SlideInModalPortal
      id={`cli-slide-in-modal${selectedAccount}`}
      containerId={creditLimitIncreaseContainerId(selectedAccount)}
      escapeModalHandler={handleEscapeAndModalHeader}
      isOpen={modalId === 'CreditLimitIncrease'}
      modalTriggerId={modalTriggerId}
      header={
        <ModalHeader
          closeModal={handleEscapeAndModalHeader}
          headerRef={headerRef}
          content={i18n({ button: 'creditLimitIncrease' }) as string}
          data-test="credit-limit-increase-modal-header"
          dataType="x button"
        />
      }
    >
      <CreditLimitIncrease
        config={mfeConfig}
        selectedAccountId={selectedAccount}
        handleClose={handleCloseModal}
        triggerAnalyticsEvent={triggerAnalyticsEvent}
      />
    </SlideInModalPortal>
  )
}

export default CreditLimitIncreaseModal
